// Turno AM/PM/HS explícito (020, SOAPIE) + día de enfermería — ver enfermeria.ts.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { TURNOS, type Turno } from './enfermeria';

export function SelectorTurno({ turno, onChange }: { readonly turno: Turno; readonly onChange: (t: Turno) => void }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1">
      <Label>{t('enfermeria.turno')}</Label>
      <fieldset className="flex flex-wrap gap-2 min-w-0 border-0 p-0" aria-label={t('enfermeria.turno')}>
        {TURNOS.map((opcion) => (
          <Button
            key={opcion}
            type="button"
            size="sm"
            variant={opcion === turno ? 'default' : 'outline'}
            aria-pressed={opcion === turno}
            onClick={() => onChange(opcion)}
          >
            {t(`enfermeria.turnos.${opcion}`)}
          </Button>
        ))}
      </fieldset>
    </div>
  );
}

/**
 * `deshabilitado` — las grillas (022, 120) calculan la fecha real de cada
 * registro con el día seleccionado AL GUARDAR: si se cambia el día con
 * marcas/filas todavía sin guardar, esas quedarían grabadas en el día
 * equivocado. Mientras haya trabajo pendiente el selector queda bloqueado.
 */
export function SelectorDiaEnfermeria({
  dia,
  onChange,
  id,
  deshabilitado,
}: {
  readonly dia: string;
  readonly onChange: (dia: string) => void;
  readonly id: string;
  readonly deshabilitado?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{t('enfermeria.diaEnfermeria')}</Label>
      <Input
        id={id}
        type="date"
        className="w-fit"
        value={dia}
        disabled={deshabilitado}
        title={deshabilitado ? t('enfermeria.diaBloqueado') : undefined}
        onChange={(e) => e.target.value && onChange(e.target.value)}
      />
      {deshabilitado && <p className="text-xs text-muted-foreground">{t('enfermeria.diaBloqueado')}</p>}
    </div>
  );
}

export function Responsable({ display }: { readonly display: string | undefined }): JSX.Element {
  const { t } = useTranslation();
  return (
    <p className="text-xs text-muted-foreground">
      {t('enfermeria.responsable')}: <span className="font-medium text-foreground">{display ?? t('enfermeria.sinResponsable')}</span>
    </p>
  );
}
